export const MISHE_HEALTH_PLAN_SLUG = 'mishehealthplan'
export const stripeFixedFee = 0.3 //  $0.30 = 30 cents
export const stripePercentageFee = 0.029 // =  2.9%
